/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@leverege/ui-elements';
export default function LogoComponent(props) {
  const {
    variant
  } = props;
  return /*#__PURE__*/React.createElement(Text, {
    variant: variant
  });
}
LogoComponent.propTypes = {
  variant: PropTypes.string
};